import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Firebase } from '../../../Core'

import * as selectors from '../quizzes.selectors'
import * as actions from '../quizzes.actions'
import * as miningActions from '../../Mining/mining.actions'
import * as audioActions from '../../../Core/Game/AudioContainer/audio.actions'

import VoteQuestion from './VoteQuestion'

const mapDispatchToProps = (dispatch) => ({
  clearResponses: bindActionCreators(actions.clearResponses, dispatch),
  changeMiningScreen: bindActionCreators(miningActions.changeMiningScreen, dispatch),
  voteQuestion: bindActionCreators(actions.voteQuestion, dispatch),
  addHowlSound: bindActionCreators(audioActions.playHowlAudio, dispatch),
})

const mapStateToProps = (state) => ({
  currentQuestion: selectors.getVoteQuestion(state),
  error: selectors.isSavedError(state),
  playerList: Firebase.selectors.getPlayerList(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(VoteQuestion))
